import { redirect } from '@tanstack/react-router';
import { useAuthStore, waitForAuthHydration } from '@/store/auth-store';

function redirectToLogin() {
  throw redirect({ to: '/login', search: { redirectPath: window.location.pathname } });
}

export function requirePermissionOrRedirect(code: string, redirectTo: string) {
  return async () => {
    await waitForAuthHydration();
    const state = useAuthStore.getState();
    if (!state.token) redirectToLogin();
    const perms = state.permissionList ?? [];
    if (!perms.includes(code)) {
      throw redirect({ to: redirectTo as '/' });
    }
  };
}

export function requireMenuOrRedirect(menuCode: string, redirectTo: string) {
  return async () => {
    await waitForAuthHydration();
    const state = useAuthStore.getState();
    if (!state.token) redirectToLogin();
    const menus = state.menuList ?? [];
    if (menus.length === 0) {
      // Empty menuList means stale session — force re-login instead of bouncing between app routes
      redirectToLogin();
    } else if (!menus.includes(menuCode)) {
      throw redirect({ to: redirectTo as '/' });
    }
  };
}
